// extracted by mini-css-extract-plugin
module.exports = {"container":"EditingHeader_container__2JTYK","swiper":"EditingHeader_swiper__1TCCz","header":"EditingHeader_header__2puJa"};